module.exports = __webpack_public_path__ + "img/LIST.a2771279.svg";